import React, { useCallback, useImperativeHandle, useState } from 'react';
import styled from 'styled-components';
import TrueImpactLoading from 'shared/components/TrueImpactLoading';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { FeedbackQuestionHandler, FeedbackSectionInfo } from '../utils';
import { useAllServiceCollections } from 'shared/apollo/pageHooks/useAllServiceCollections';
import { SectionServiceCollectionRender } from '../../../ReportBuilder/Components/ImpactSummary/SectionServiceCollection';

const StyledDiv = styled.div`
  .service-collection-textfield {
    background-color: ${COLORS.whiteBase};
  }
`;

const ServiceCollection = React.forwardRef<
  FeedbackQuestionHandler,
  FeedbackSectionInfo
>(({ reportId, questionId, answer, questionText, question }, forwardRef) => {
  const [text, setText] = useState<string>(answer);
  const { data: serviceCollections } = useAllServiceCollections({ reportId });

  const handleChange = useCallback(
    (questionId: number, value: string) => {
      setText(value);
    },
    [setText],
  );

  useImperativeHandle(forwardRef, () => ({
    reportId,
    questionId,
    answer: () => text,
    errorText: () =>
      text && text.length > 0 ? undefined : 'Please select one of the options',
  }));

  if (!serviceCollections || serviceCollections.length === 0) {
    return <TrueImpactLoading />;
  }

  return (
    <StyledDiv>
      <TrueImpactText variant="heading-subheading" className="question-text">
        {questionText}
      </TrueImpactText>
      <SectionServiceCollectionRender
        data={serviceCollections}
        onChange={handleChange}
        questionId={questionId}
        guidanceText={undefined}
        value={text}
      />
    </StyledDiv>
  );
});

export default ServiceCollection;
